import { ContactListItemProps } from "../types"
import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { useTheme } from "~/ui/styled"
import { ColumnFlex, BetweenFlex, IconFont, Text } from "~components/El"
import { Avatar } from "~widgets/avatar"
import { OnlineStatus } from "~widgets/online-status"
import styled from "~/ui/styled"

const ItemRow = styled.button<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  margin: 0;
  border: none;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  text-align: left;
  font: inherit;
  color: inherit;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  background: transparent;
`

const ItemMain = styled.div<{ $borderColor: string; $isLastItem?: boolean }>`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-left: 10px;
  padding: 15px 0;
  border-bottom: ${({ $isLastItem, $borderColor }) =>
    $isLastItem ? "none" : `${StyleSheet.hairlineWidth}px solid ${$borderColor}`};
`

const ContactListItem: React.FC<ContactListItemProps> = ({
  members = [],
  contact,
  isSelectMode,
  isLastItem,
  selecteds,
  onItemClick,
}) => {
  const theme = useTheme()
  const checked = selecteds?.find((i) => i.user_id === contact.user_id)
  const disabled = members.findIndex((i) => i.user_id === contact.user_id) > -1
console.log(contact?.user?.online,'contact.user');

  return (
    <ItemRow
      type="button"
      $disabled={disabled}
      disabled={disabled}
      style={{ backgroundColor: theme.colors.blockBackground }}
      onClick={() => !disabled && onItemClick?.(contact)}
    >
      <Avatar size={40} avatar={contact.user.avatar} name={contact.displayName} />
      <ItemMain $borderColor={theme.colors.border} $isLastItem={isLastItem}>
        <ColumnFlex flex={1} minWidth={0} style={{ height: "auto", width: "100%" }}>
          <Text
            color={theme.colors.text}
            fontSize={theme.fontSizes.md}
            fontWeight="600"
            mb="3px"
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
          >
            {contact.displayName}
          </Text>
          <OnlineStatus last_seen={contact.user.last_seen} online={contact.user.online} />
        </ColumnFlex>
        {isSelectMode && !disabled && (
          <IconFont
            name={checked ? "cg" : "yuan"}
            size={15}
            color={checked ? theme.colors.primary : theme.colors.border}
          />
        )}
        {disabled && (
          <Text color={theme.colors.text} fontSize={12}>
            已邀请
          </Text>
        )}
      </ItemMain>
    </ItemRow>
  )
}

export default ContactListItem
